export const APP_ENV = {
    PRODUCTION: 'production',
    STAGING: 'staging',
    LOCAL: 'local',
    DEVELOPMENT: 'development',
} as const;

export type AppEnv = (typeof APP_ENV)[keyof typeof APP_ENV];

const envValue = import.meta.env.VITE_APP_ENV;
const VALID_ENV_VALUES = Object.values(APP_ENV);

if (!VALID_ENV_VALUES.includes(envValue)) {
    throw new Error(
        `Invalid VITE_APP_ENV: "${envValue}". Expected one of: ${VALID_ENV_VALUES.join(', ')}`,
    );
}

export const VITE_APP_ENV: AppEnv = envValue as AppEnv;
export const VITE_APP_URL: string = import.meta.env.VITE_APP_URL;
export const VITE_SESSION_DOMAIN: string = import.meta.env.VITE_SESSION_DOMAIN;
export const VITE_ASSET_CDN_URL: string | undefined = import.meta.env.VITE_ASSET_CDN_URL;
export const VITE_IMAGE_CDN_URL: string | undefined = import.meta.env.VITE_IMAGE_CDN_URL;
export const VITE_SENTRY_DSN: string | undefined = import.meta.env.VITE_SENTRY_DSN;

export const IS_PROD = VITE_APP_ENV === APP_ENV.PRODUCTION;
